import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import React from 'react';

function ChartLoadingOverlay({ loading }) {
  return (
    <div className="w-full h-full absolute top-0 left-0 right-0 bottom-0 bg-[#e5e7eb80] z-[10]">
      <Spin
        spinning={loading}
        indicator={<LoadingOutlined spin />}
        size="large"
        className="absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-[11]"
      ></Spin>
    </div>
  );
}

export default ChartLoadingOverlay;
